import {Reply} from "../../../schema";
import cn from "classnames";
import React from "react";
import RatingBadge from "./RatingBadge";
import IconFullStar from "../../icon/IconFullStar";

type Props = {
  reply: Reply;
  index: number;
};

export default function EvaluationReply({reply, index}: Props) {
  const numberedReply = reply.replyType === "rating" || reply.replyType === "range-number" || reply.replyType === "percent";
  return (
    <div className={cn("py-4",
      {"border-t border-gray": index > 0, "flex flex-row justify-between": numberedReply || !reply.answer})}>
      <div className="font-bold">{reply.label}</div>
      {!reply.answer && <span className="text-gray-dark">No answer</span>}
      {reply.answer &&
        <>
          {(reply.replyType === "text" || reply.replyType === "review") &&
            <div className="italic border-l-2 border-blue px-4 mt-2">
              {reply.answer}
            </div>
          }
          {reply.replyType === "range-number" &&
            <RatingBadge id={reply.fieldId} value={Number(reply.answer)} caption={`${reply.answer} / 10`}/>
          }
          {reply.replyType === "percent" &&
            <RatingBadge id={reply.fieldId} value={Number(reply.answer)} caption={`${reply.answer}0%`}/>
          }
          {reply.replyType === "rating" &&
            <RatingBadge id={reply.fieldId} value={Number(reply.answer)}
                         caption={<>{reply.answer} <IconFullStar className="ml-0.5"/></>}/>
          }
        </>
      }
    </div>
  );
}
